import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../core/core.module';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import * as fromStore from './store';
import { ShopifyStatusColorPipe } from './pipes/shopify-status-color.pipe';
import { LanguageNgrxModule } from '@teamfoster/sdk/language-ngrx';
import { ShopifyMetaFieldColorLabelPipe } from './pipes/shopify-meta-field-color.pipe';
import { ShopifyMetaFieldsPipe } from './pipes/shopify-metafields.pipe';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    RouterModule,
    MatSnackBarModule,
    LanguageNgrxModule,
    StoreModule.forFeature(fromStore.featureKey, fromStore.reducers, {
      metaReducers: fromStore.metaReducers,
    }),
    EffectsModule.forFeature(fromStore.effects),
  ],
  declarations: [ShopifyStatusColorPipe, ShopifyMetaFieldColorLabelPipe, ShopifyMetaFieldsPipe],
  exports: [ShopifyStatusColorPipe, ShopifyMetaFieldColorLabelPipe, ShopifyMetaFieldsPipe],
})
export class ShopModule {}
